import request from '@/utils/request'

import logger from '@/utils/logger'

import API from './base'

// Use v1 endpoint for UAE KYC instead of v2
const getUaeKycApiBaseUrl = () => {
  const baseUrl = import.meta.env.VITE_APP_KYC_API_BASE_URL || ''
  return baseUrl.replace('/kyc/v2', '/kyc/v1')
}

class UaeKycAPI extends API {
  fetch = (sessionId) => {
    return request({
      method: 'GET',
      path: `${this.uri}/customer/kyc/session/${sessionId}`,
    })
  }

  verificationStatus = (sessionId, data) => {
    return request({
      method: 'POST',
      path: `${this.uri}/customer/kyc/notify/${sessionId}`,
      data,
    })
  }

  logUserAction(uaeKycSessionId, data) {
    logger.trace('Submit UAE KYC session log', uaeKycSessionId, data)

    return request({
      method: 'POST',
      trackingKey: 'risk-logging_uae-kyc_UAE-KYC-SESSION-ID_log',
      path: `/risk-logging/uae-kyc/${uaeKycSessionId}/log`,
      data,
    })
  }
}

export default new UaeKycAPI(getUaeKycApiBaseUrl())
